/**
 * 商品管理api
 */
export default {
  /**
   * 全部商品
   */
  // 列表
  selectProductList: "/productInfo/selectProductList",  // 商品列表
  changeMallStatus: "/productInfo/updateSaleStatus",    // 上下架
  updateStoreInventory: "/productInfo/updateStoreInventory",    // 新增库存
  selectProductAndInventoryInfo: "/productInfo/selectProductAndInventoryInfo",    // 商品详情
  
  /**
   * 分类列表
   */
  getCategoryInfoList: "/productCategory/list",   // 分类列表
  
   /**
   * 费用设置
   */
  getShopFeeSetList: "/storeFeeSet/list",  // 列表
  updateShopFeeAmount: "/storeFeeSet/updateShopFeeAmount",   // 修改金额
  updateShopFeeStatus: "/storeFeeSet/updateShopFeeStatus",   // 修改状态
  
  /**
   * 运费模板
   */
  getFreightTemplateList: "/freightTemplate/list",   // 运费模板-列表
  addFreightTypeSet: "/freightTemplate/addFreightTypeSet",  // 多商品运费设置
  freightTypeSetDetail: "/freightTemplate/freightTypeSetDetail",   // 多商品运费设置-详情
  saveFreightTemplate: "/freightTemplate/save",    // 新增运费模板
  queryFreightTemplateById: "/freightTemplate/byId",  // 修改详情
  updateFreightTemplate: "/freightTemplate/update",   // 修改运费模板
  getReleatedProductList: "/freightTemplate/productList",   // 关联商品-列表
  getFreightProductList: "/freightTemplate/freightProductList",  // 关联商品-新增商品列表
  addFreightProduct: "/freightTemplate/addFreightProduct",   // 新增商品
  deleteFreightTemplateProduct: "/freightTemplate/deleteProduct",   // 删除关联商品
  deleteFreightTemplate: "/freightTemplate/delete",  // 删除运费模板
 

 
  
}
